import React from 'react';

import { flagStyles } from '../settings';

const SvgSC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4632px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSC;
